import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  reportContent: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '270px',
    overflowY: 'auto',
    width: '100%',
    marginTop: '-16px',
  },
  reportItem: {
    marginBottom: '16px',
  },
  reportText: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: `${colors.black} !important`,
  },
  cardRoot: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cardHeaderText: {
    fontSize: fonts.sizes.xsmall,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.4px',
    lineHeight: '16px',
    color: colors.black,
  },
});

export default useStyles;
